import { render, staticRenderFns } from "./IssuesComment.vue?vue&type=template&id=2895dc99&"
import script from "./IssuesComment.vue?vue&type=script&lang=js&"
export * from "./IssuesComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports